import React from "react";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import BASE_URL from "../config";
import {
  FaSprayCan,
  FaAward,
  FaTshirt,
  FaGift,
} from "react-icons/fa";
import { FaBagShopping } from "react-icons/fa6";
import "./Home.css";

function Home() {
  const [products, setProducts] = useState([]);
  const navigate = useNavigate();
  useEffect(()=>{

  fetch(`${BASE_URL}/api/products/allproducts`)
  .then(res=>res.json())
  .then(data=>{

    if(data.success){
      setProducts(data.products);
    }

  })
  .catch(err=>console.log(err));


},[]);
  return (
    <>
      <section className="hero-section">
       <div
  id="heroSlider"
  className="carousel slide"
  data-bs-ride="carousel"
  data-bs-interval="4000"
  data-bs-pause="false"
>
          <div className="carousel-indicators">
            <button
              type="button"
              data-bs-target="#heroSlider"
              data-bs-slide-to="0"
              className="active"
            ></button>

            <button
              type="button"
              data-bs-target="#heroSlider"
              data-bs-slide-to="1"
            ></button>

            <button
              type="button"
              data-bs-target="#heroSlider"
              data-bs-slide-to="2"
            ></button>
          </div>

          <div className="carousel-inner">
            {/* Slide 1 */}
            <div className="carousel-item active">

              <div className="hero-overlay"></div>

              <div className="hero-content">
                <h1>SAH?</h1>

                <h3>EVERY MOOD HAS A SCENT.</h3>

                <div className="gold-line"></div>

                <p>
                 Premium scented pouches for your car, closet, and beyond.
                </p>

                <p>Scent Your Mood</p>

                <button>SHOP NOW</button>
              </div>
               <div className="hero-image-wrapper">
    <img src="/image1.png" alt="" className="hero-image" />
  </div>
            </div>

            {/* Slide 2 */}
            <div className="carousel-item">

              <div className="hero-overlay"></div>

              <div className="hero-content">
                <h1>SAH?</h1>

                <h3>EVERY MOOD HAS A SCENT.</h3>

                <div className="gold-line"></div>

                <p>
                  Premium car air fresheners inspired by the world's greatest
                  passion.
                </p>

                <p>Collect your pride. Drive your mood.</p>

                <button>SHOP NOW</button>
              </div>
              <div className="hero-image-wrapper">
  <img src="/image2.png" alt="" className="hero-image" />
</div>
            </div>

            {/* Slide 3 */}
            <div className="carousel-item">

              <div className="hero-overlay"></div>

              <div className="hero-content">
                <h1>SAH?</h1>

                <h3>EVERY MOOD HAS A SCENT.</h3>

                <div className="gold-line"></div>

                <p>
                  Premium car air fresheners inspired by the world's greatest
                  passion.
                </p>

                <p>Collect your pride. Drive your mood.</p>

                <button>SHOP NOW</button>
              </div>
              <div className="hero-image-wrapper">
  <img src="/image3.png" alt="" className="hero-image" />
</div>
            </div>
          </div>
        </div>
      </section>
      <section className="features-section">
  <div className="features-container">

    <div className="feature-card">
      <div className="feature-icon">
        <FaSprayCan />
      </div>

      <h4>SIGNATURE SCENTS</h4>

      <p>
        Premium fragrances inspired by every mood.
      </p>
    </div>

    <div className="feature-card">
      <div className="feature-icon">
        <FaAward />
      </div>

      <h4>PREMIUM CRAFTSMANSHIP</h4>

      <p>
        Designed with precision. Made to last.
      </p>
    </div>

    <div className="feature-card">
     <div className="feature-icon">
    <FaBagShopping />
  </div>

      <h4>COLLECTIBLE DESIGNS</h4>

      <p>
        Inspired by nations. Crafted with pride.
      </p>
    </div>

    <div className="feature-card">
      <div className="feature-icon">
        <FaGift />
      </div>

      <h4>CRAFTED FOR THE JOURNEY</h4>

      <p>
        Take your passion wherever you go.
      </p>
    </div>

  </div>
</section>
<section className="country-section">

  <div className="country-heading">

    <span>COLLECTIONS</span>

    <h2>
      EXPLORE BY COUNTRY
    </h2>

  <button onClick={() => navigate("/shop")}>
  VIEW ALL
</button>

  </div>
<div className="country-container">

{
products.slice(0,4).map((product)=>(

<div className="country-card" key={product.id}>

<img
src={`https://sahscents.xpertoneevents.com/uploads/${product.image}`}
alt={product.name}
/>


<h4>
{product.name}
</h4>


<p>
{product.description}
</p>


<strong>
AED {product.price}
</strong>


</div>

))

}

</div>


</section>
    </>
  );
}

export default Home;